import {
  PlatformPaths,
  PlanPaths,
  ProductPaths,
  ConnectionPaths,
  DataPaths,
  CenterPaths,
  InsightPaths,
} from './submodule-paths';

export {
  PlatformPaths,
  PlanPaths,
  ProductPaths,
  ConnectionPaths,
  DataPaths,
  CenterPaths,
  InsightPaths,
};

export const SellerPaths = {
  ROOT: '/',
  ERROR_PAGE: '/errorpage',

  ...PlatformPaths,
  ...PlanPaths,
  ...ProductPaths,
  ...ConnectionPaths,
  ...DataPaths,
  ...CenterPaths,
  ...InsightPaths,
};

export const IMPaths = {
  IM_ROOT: '/',
  IM_HOMEPAGE: '/seller/im',
  IM_NO_PERMISSION: '/nopermission',
};

export const PartnerPaths = {
  PARTNER_CREATOR_MARKETPLACE: `/partner/connection/find-creator/creator-marketplace`,
  PARTNER_CREATOR_PROFILE: `/partner/connection/find-creator/creator-marketplace/creator-detail`,
  PARTNER_INVITATION_HISTORY: `/partner/connection/find-creator/invitation-history`,
};

export const MenuRootPaths = {
  COLLABORATION: '/collaboration/root',
  CONNECTION: '/connection/creator/root',
  DATA: '/data/root',
  ACCOUNT: '/platform/account/root',
};

export * as Utils from './utils';
